import {useState} from 'react';
import {
  CloseWrapper,
  DescriptionText,
  DeviceImage,
  Divider,
  Header,
  ImageBlock,
  ImageWrapper,
  ModalContent,
  Section,
  SectionTitle,
  Title,
  ToggleExpand,
  ToggleIcon,
} from './styles.ts';
import Modal from '@atomaro/ui-kit/components/Modal/Modal';
import CloseButton from '@atomaro/ui-kit/components/Button/CloseButton/CloseButton';

import ChevronIcon from '../../../shared/assets/img/chevron_down.svg';
import {DeviceCardData} from 'widgets/devicesInfo/consts/cards.consts.ts';

interface DeviceModalProps {
  open: boolean;
  onClose: () => void;
  deviceId?: string;
  device?: DeviceCardData;
}

export const DeviceInfoModal = ({open, onClose, device, deviceId}: DeviceModalProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Modal
      isOpen={open}
      onClickOverlay={onClose}
      centered={true}
      style={{padding: 0, width: '100%', maxWidth: '480px'}}
    >
      <ModalContent>
        <Header>
          <Title>{device?.name ?? `Устройсво не найдено`}</Title>
          <CloseWrapper>
            <CloseButton onClick={onClose} size={'s'} />
          </CloseWrapper>
        </Header>

        <Divider />

        {device && (
          <>
            <ImageBlock>
              <ImageWrapper>
                <DeviceImage src={device.img} alt={device.name} />
              </ImageWrapper>
            </ImageBlock>

            <Divider />
          </>
        )}
        <Section>
          <SectionTitle>Описание</SectionTitle>

          <DescriptionText expanded={expanded}>
            {device?.description ??
              `Устройсво с uuid ${deviceId} не найдено в реестре, пожалуйста, обратитесь в службу поддержки`}
          </DescriptionText>
        </Section>
      </ModalContent>
      <ToggleExpand expanded={expanded} onClick={() => setExpanded((v) => !v)}>
        {expanded ? 'Свернуть' : 'Развернуть'}
        <ToggleIcon src={ChevronIcon} expanded={expanded} />
      </ToggleExpand>
    </Modal>
  );
};
